"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dashboard_de_de = void 0;
function dashboard_de_de() {
    return {
        "dashboard.widgets.count.choices.users": "Kunden",
        "dashboard.widgets.count.choices.cmspages": "CMS-Seiten",
        "dashboard.widgets.count.choices.products": "Produkte",
        "dashboard.widgets.count.choices.checkin.users": "Checkin-Benutzer",
        "dashboard.widgets.count.choices.visits_lastweek": "Besuche letzte Woche",
        "dashboard.widgets.count.choices.visits_lastmonth": "Besuche letzten Monat",
        "dashboard.widgets.count.choices.unverified_users": "Unverifizierte Benutzer",
        "dashboard.widgets.count.choices.workflows": "Workflows",
        "dashboard.widgets.count.choices.orders": "Bestellungen",
        "dashboard.widgets.count.choices.open_orders": "Offene Bestellungen",
        "dashboard.widgets.event.date": "Datum",
        "dashboard.widgets.event.title": "Titel",
        "dashboard.widgets.event.numberentries": "Wie viele Einträge sollen angezeigt werden?",
        "dashboard.widgets.event.appointmentcounter": "Noch ${count} weitere Termine vorhanden",
        "dashboard.widgets.event.appointmentcountersingular": "Noch ${count} weiterer Termin vorhanden",
        "dashboard.widgets.event.noappointmentsavailable": "Keine Termine vorhanden",
        "dashboard.widgets.lastnewuserregistrations.name": "Name",
        "dashboard.widgets.lastnewuserregistrations.createdat": "Erstelldatum",
        "dashboard.widgets.lastnewuserregistrations.usercounter": "Insgesamt ${count} Benutzer vorhanden",
        "dashboard.widgets.lastnewuserregistrations.nousersavailable": "Keine Benutzer vorhanden",
        "dashboard.widgets.externalcount.noconfig": "Es wurde noch keine Konfiguration angelegt.",
        "dashboard.widgets.calendar.whichcalendar": "Welcher Kalender soll angezeigt werden?",
        "dashboard.widgets.calendar.timegridweek": "Woche",
        "dashboard.widgets.calendar.daygridmonth": "Monat",
        "dashboard.widgets.dateformat.short": "Kurz: dd.MM.yy, hh:mm",
        "dashboard.widgets.dateformat.medium": "Medium: dd.MM.yyyy, h:mm:ss",
        "dashboard.widgets.dateformat.long": "Lang: d.MMMM y, h:mm:ss a z",
        "dashboard.widgets.dateformat.shortdate": "Datum (kurz): dd.MM.yy",
        "dashboard.widgets.dateformat.mediumdate": "Datum (medium): dd.MM.yyyy",
        "dashboard.widgets.dateformat.longdate": "Datum (lang): d. MMMM yyyy",
        "dashboard.widgets.dateformat.fulldate": "Datum (voll): EEEE, d. MMMM yyyy",
        "dashboard.widgets.dateformat.shorttime": "Zeit (kurz): hh:mm",
        "dashboard.widgets.dateformat.mediumtime": "Zeit (medium): hh:mm:ss",
        "dashboard.widgets.dateformat.longtime": "Zeit (lang): h:mm:ss z",
        "dashboard.widgets.dateformat.fulltime": "Zeit (voll): h:mm:ss a zzzz",
        "dashboard.widgets.dateformat.currency": "Währung",
        "dashboard.widgets.dateformat.--": "--",
        "dashboard.widgets.image.clickaction.link": "Verlinkung",
        "dashboard.widgets.image.clickaction.openindialog": "Öffnen in Dialog",
        "dashboard.widgets.contextcontainer.notemplatedefined": "Keine Inhaltsvorlage definiert. Bearbeiten Sie das Widget und geben Sie unter Inhalt an, welche Daten wie angezeigt werden sollen.",
        "dashboard.widgets.contextcontainer.nomodel": "Es konnten keine Daten geladen werden. Mögliche Gründe:",
        "dashboard.widgets.contextcontainer.nomodel.nostoreloaded": "Der Datenspeicher konnte nicht geladen werden.",
        "dashboard.widgets.contextcontainer.nomodel.nodatasource": "Es wurde keine Datenquelle ausgewählt.",
        "dashboard.widgets.contextcontainer.nomodel.queryparameter": "URL-Parameter nicht vorhanden.",
        "dashboard.widgets.contextcontainer.nomodel.routeparameter": "Routenparameter nicht vorhanden.",
        "dashboard.widgets.contextcontainer.nomodel.fixedid": "Fixe ID nicht vorhanden.",
        "dashboard.widgets.contextcontainer.nomodel.contextproperty": "Kontext-Eigenschaft nicht vorhanden.",
        "dashboard.widgets.contextcontainer.nomodel.nodataselector": "Keine Datenauswahl getroffen.",
        "dashboard.widgets.contextcontainer.dataselector.queryparameter": "URL-Parameter",
        "dashboard.widgets.contextcontainer.dataselector.routeparameter": "Routenparameter",
        "dashboard.widgets.contextcontainer.dataselector.fixedid": "Fixe ID",
        "dashboard.widgets.contextcontainer.dataselector.contextproperty": "Kontext-Eigenschaft"
    };
}
exports.dashboard_de_de = dashboard_de_de;
